import { specialFont } from "../../Infrastructure/Theme/fontFamily"
import { Box, Button, Typography, styled } from "@mui/material"

export const basicsStepSx = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100dvh',
    overflow: 'hidden'
  },
  header: {
    minHeight: '70px',
    flexShrink: 0
  },
  form: {
    flexGrow: 1,
    width: '100%',
    overflowY: 'auto',
    minHeight: 0,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    WebkitOverflowScrolling: 'touch'
  },
  content: {
    pt: '50px',
    pb: '20px',
    px: { xs: 2, sm: 2, md: 10, lg: 10, xl: 10 }
  },
  radioIcon: {
    '& .MuiSvgIcon-root': {
      fontSize: '30px !important'
    }
  },
  radioItem: {
    width: '100%',
    border: '1px solid #1c1d1f',
    p: 1,
    m: '3px',
    borderRadius: '30px !important',
    height: '76px'
  },
  error: {
    textAlign: 'center',
    mt: 2
  },
  footer: {
    flexShrink: 0
  }
}

export const learningObjectivesStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100dvh',
    overflow: "hidden"
  },
  formContainer: {
    flexGrow: 1,
    width: '100%',
    overflowY: 'auto',
    pt: { xs: '30px', sm: '50px' },
    pb: '40px',
    minHeight: 0,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    WebkitOverflowScrolling: "touch",
    px: { xs: 2, sm: 2, md: 10, lg: 10, xl: 10 }
  },
  gridBox: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    gap: 2
  },
  footerBox: {
    flexShrink: 0
  },
  headerBox: {
    minHeight: '70px',
    flexShrink: 0
  },
  questionBox: {
    height: { xs: "auto", md: "100px" }
  }
}

export const curriculumSx = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100dvh',
    overflow: "hidden"
  },
  headerBox: {
    minHeight: '70px',
    flexShrink: 0
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    pt: { xs: '30px', sm: '50px' },
    pb: "40px",
    flexGrow: 1,
    minHeight: 0,
    width: '100%',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    WebkitOverflowScrolling: "touch",
  },
  sectionsBox: {
    width: {
      xs: "90%", sm: "90%", md: "80%", lg: "75%", xl: "70%"
    },
    my: 2
  },
  sectionBox: {
    border: 1,
    p: 2,
    borderRadius: "30px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  sectionHeaderBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  textField: { mt: 1, "& .MuiOutlinedInput-root": { borderRadius: "10px" } },
  addSectionBox: {
    p: 2,
    border: 1,
    borderRadius: "30px",
    height: "100%",
    minHeight: "280px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    cursor: "pointer",
    transition: "0.3s",
    "&:hover": {
      backgroundColor: "#f9f9f9",
    },
  },
  addSectionBoxButton: { fontSize: "16px", fontWeight: "bold", textTransform: "none" },
  footerBox: {
    flexShrink: 0
  },
};
export const courseDetailsSx = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100dvh',
    overflow: "hidden"
  },
  headerBox: {
    minHeight: '80px',
    flexShrink: 0
  },
  content: {
    flexGrow: 1,
    width: '100%',
    height: "auto",
    overflowY: 'auto',
    pt: '50px',
    pb: '50px',
    minHeight: 0,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    WebkitOverflowScrolling: "touch",
  },
  mainGridBox: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  subGrid1Box: {
    display: { lg: "flex" },
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    mb: 6,
    px: { lg: 5, md: 5, sm: 5, xs: "20px" }
  },
  subGrid2Box: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "100%",
    pb: { sm: 8, xs: 8 }
  },
  imageBox: {
    maxWidth: { md: "70%", lg: "100%", xlg: "100%" },
    px: { xs: 2, sm: 0 },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  quillBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
  },
  error: {
    textAlign: 'center',
  },
  promoLinkTextField: {
    mt: "30px"
  },
  footerBox: {
    flexShrink: 0
  },
}
export const summarySx = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100dvh',
    overflow: "hidden"
  },
  headerBox: {
    minHeight: '70px',
    flexShrink: 0
  },
  content: {
    flexGrow: 1,
    width: '100%',
    minHeight: 0,
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    WebkitOverflowScrolling: "touch",
  },
  footerBox: {
    flexShrink: 0
  },
}
export const classScheduleSx = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100dvh',
    overflow: "hidden"
  },
  headerBox: {
    minHeight: '70px',
    flexShrink: 0
  },
  form: {
    flexGrow: 1,
    width: '100%',
    overflowY: 'auto',
    minHeight: 0,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    WebkitOverflowScrolling: "touch",
  },
  content: {
    pt: '50px',
    pb: "200px",
  },
  pageTextDesc: {
    px: { lg: 10, sm: 4, xs: 1 },
    width: {
      lg: '80%',
      md: '80%',
      sm: '100%',
      xs: '100%',
    },
  },
  mainGridBox: {
    py: 5,
    px: { lg: 10, sm: 4, xs: 1 },
    justifyContent: 'center'
  },
  subGrid1: {
    mb: { sm: 3, xs: 3, md: 4 }
  },
  subGrid1Box: {
    display: {
      xs: 'flex',
      sm: 'flex',
      md: 'flex',
      lg: 'block',
    },
    flexDirection: {
      xs: 'column',
      sm: 'row',
      md: 'row',
      lg: 'row',
    },
    justifyContent: {
      xs: 'space-between',
      sm: 'space-between',
      md: 'space-between',
    },
    gap: 1,
    width: { xs: '100%', sm: '100%', md: '100%', lg: '66%' },
  },
  firstClassBox: {
    pt: 3,
    width: '100%'
  },
  firstClassTitle: { pb: 2 },
  courseDurationBox: {
    pt: 3,
    width: { xs: "100%", sm: '60%' }
  },
  courseDurationTitle: { pb: 2 },
  courseDurationAdornment: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '10px',
    height: '30px',
    fontWeight: 'bold',
  },
  maxLearnersBox: {
    pt: 3,
    width: { xs: "100%", sm: '60%' }
  },
  maxLearnersTitle: {
    pb: 2
  },
  maxLearnersAdornment: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '10px',
    height: '30px',
    fontWeight: 'bold',
  },
  timezoneText: {
    pb: 1,
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  dayBox: {
    display: 'flex',
    alignItems: 'center',
    mb: 1,
    width: '100%'
  },
  dayCheckBox: (theme) => ({
    '& .MuiSvgIcon-root': {
      fontSize: '30px !important',
    },
    cursor: 'pointer',
    color: theme.palette.primary.main,
  }),
  dayNameTextBox: { minWidth: { sm: '100%', md: '23%', lg: '23%' } },
  dayNameTextField: { pl: { md: 2 }, whiteSpace: 'nowrap', textTransform: 'capitalize', textAlign: { xs: 'center', md: 'start' } },
  dayNameColonField: {
    display: { xs: 'none', md: 'inline' },
    whiteSpace: 'nowrap',
  },
  dayTimeBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid',
    borderRadius: '30px',
    flexDirection: {
      xs: 'column',
      md: 'row',
      lg: 'row',
      xl: 'row',
    },
    gap: 2,
    ml: 2,
    px: 1,
    width: '100%'
  },
  selectTimeBox: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      sm: 'row',
      md: 'row',
      lg: 'row',
    },
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 1,
    mb: { xs: 3, sm: 1 },
    mr: { xs: 0, sm: "20px" },
    width: {
      xs: "100%",
      sm: "auto",
    },
    gap: {
      xs: 1,
      sm: 2,
      md: 2,
      lg: 2,
      xl: 2,
    },
  },
  error: { textAlign: 'center', mt: 2, px: 5 },
  footerBox: { flexShrink: 0 }
}
export const CourseMainBox = styled(Box)((theme) => ({
  minHeight: '90vh'
}))
export const StepsValue = styled('span')(() => ({
  fontFamily: specialFont,
}))
export const Header = styled(Box)((theme) => ({
  minHeight: "70px",
  width: "100%",
  position: "fixed",
  top: 0,
  background: "white",
  zIndex: 50,
  boxShadow:
    "0px 4px 4px rgba(0, 0, 0, 0.25), 0px -4px 4px rgba(0, 0, 0, 0.25)",
}))
export const Span = styled("span")(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
}))
export const ExitTypo = styled(Typography)(({ theme }) => ({
  curser: "pointer",
  fontWight: "700 !important",
  paddingRight: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    fontSize: "25px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}))
export const StepsTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  lineHeight: 1.4,
  textAlign: "left",
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    textAlign: "center",
  },
}));

export const ContinueButton = styled(Button)((theme) => ({
  textTransform: "capitalize",
  border: "none",
  height: "50px",
}))
export const PreviousButton = styled(Button)((theme) => ({
  textTransform: "capitalize",
  border: "none",
  height: "50px",
}))
// ======================
export const LogoTypo = styled(Typography)(({ theme }) => ({
  fontFamily: `${specialFont} !important`,
  fontWight: "700 !important",
  textDecoration: "none",
  mb: 0,
  display: { md: "flex" },
  fontSize: "40px",
  lineHeight: "51px",
  [theme.breakpoints.down("md")]: {
    fontSize: "25px",
    padding: theme.spacing(1),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}))
export const Footer = styled(Box)(({ theme }) => ({
  height: "80px",
  width: "100%",
  boxShadow: "0px -4px 4px rgba(0, 0, 0, 0.25)",
  background: "white",
}))
export const TitleText = styled(Typography)((theme) => ({
  fontSize: "16px",
  fontFamily: specialFont,
}))
export const Details = styled(Typography)((theme) => ({
  fontSize: "22px",
  fontFamily: specialFont,
}))
export const FullName = styled(Typography)((theme) => ({
  fontSize: "28px",
}))
export const TopHeadingBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {},
}))
export const TopHeading = styled(Typography)(({ theme }) => ({
  marginTop: 12,
  fontWeight: 700,
  fontSize: "2.2rem",
  lineHeight: 1.25,
  letterSpacing: "-.05rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}))
export const Description = styled(Typography)(({ theme }) => ({}))
export const DescriptionBox = styled(Box)(({ theme }) => ({
  maxWidth: "70%",
  paddingTop: 32,
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
  },
}))
export const QuestionName = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  fontSize: "20px",
  [theme.breakpoints.down("md")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
  },
}))
export const SectionQuestion = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  fontSize: "16px",
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
  },
}))
export const styles = {
  main: {
    height: "100vh",
  },
  backdrop: {
    backgroundColor: "transparent",
  },
}
export const MainBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "450px",
  backgroundColor: "white",
  paddingBottom: 5,
  pt: 2,
  [theme.breakpoints.down("md")]: {},
}))
export const CreateAccButton = styled("button")(({ theme }) => ({
  borderRadius: "30px",
  border: "1px solid black",
  fontFamily: "Inter, sans-serif",
  fontWeight: 800,
  position: "relative",
  height: "41px",
  width: "200px",
  background: theme.palette.primary.main,
  color: "#fff",
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
    marginTop: "30px",
  },
}))
export const Heading = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  color: theme.palette.primary.main,
  fontSize: "36px",
  [theme.breakpoints.down("md")]: {},
}))
export const SignUpTextLink = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: theme.palette.primary.main,
  cursor: "pointer",
  [theme.breakpoints.down("md")]: {},
}))
export const CharacterCount = styled("p")(({ theme }) => ({
  fontsize: "22px",
  textAlign: "end",
  fontWeight: "bold",
}))
export const CourseImage = styled("p")(({ theme }) => ({
  fontsize: "26px",
  textAlign: "center",
  fontWeight: "bold",
}))
export const FormBox = styled(Box)(({ theme }) => ({
  width: "50%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    width: "80%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}))
export const ChoiceTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  lineHeight: 1.2,
  letterSpacing: "-.02rem",
  fontSize: "16px",
}))
export const EduBlankTitle = styled(Typography)(({ theme }) => ({
  fontSize: "28px",
  [theme.breakpoints.down("md")]: {
    fontSize: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
  },
}))
export const QuestionFormBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    width: "80%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    paddingTop: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
}))
export const FormBoxEdu = styled(Box)(({ theme }) => ({
  width: "50%",
  [theme.breakpoints.down("md")]: {
    width: "80%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}))
export const AvatarBox = styled(Box)((theme) => ({
  position: "absolute",
  borderRadius: "30px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  backgroundColor: "white",
}))

export const VerifyEmailMainBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-end",
  width: "358px",
  height: "390px",
  backgroundColor: "white",
  paddingBottom: 5,
}))
export const VerifyEmailFormBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}))
export const CountText = styled('span')(({ theme }) => ({
  display: "inline-block",
  width: "40px",
  textAlign: "left"
}))
export const ErrorBlockLarge = styled('div')(({ theme }) => ({
  color: "red",
  fontSize: "12px",
  display: "block",
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}))
export const ErrorBlock = styled('h6')(({ theme }) => ({
  display: "block",
  color: "red",
  textAlign: "start",
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),

}))
export const ErrorBlockSmall = styled('h6')(({ theme }) => ({
  color: "red",
  display: "none",
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    display: "block",
  },
}))
export const ClassScheduleTitle = styled('h6')(({ theme }) => ({
  fontsize: "16px",
  [theme.breakpoints.down("sm")]: {
  },
}))
